export default "__VITE_ASSET__770cd3f2__"